export const sellsToFinal = (product) => product?.sellToFinal !== false && product?.sellToFinal !== 0;
export const sellsToReseller = (product) => product?.sellToReseller === true || product?.sellToReseller === 1;
export function categoryOf(product) {
  if (product.fulfillmentType === "giftcard") return "Gift cards";
  const name = `${product.name || ""} ${product.planLabel || ""}`;
  const brand = name.match(/netflix|disney\+?|prime\s*video|amazon|hbo|max\b|spotify|youtube|crunchyroll|paramount\+?|apple\s*tv|iptv|vix|canva|office|microsoft/i);
  if (brand) return brand[0].replace(/^amazon$/i, "Prime Video").replace(/^hbo$/i, "Max");
  return ({ recharge: "Recargas", mailbox: "Correos", license: "Licencias", device: "Televisión" })[product.fulfillmentType] || "Otros servicios";
}
export function formatMoney(value, currency = "COP", symbol) {
  if (symbol) return `${symbol}${new Intl.NumberFormat("es-CO", { maximumFractionDigits: ["COP", "CLP", "PYG"].includes(currency) ? 0 : 2 }).format(Number(value || 0))}`;
  return new Intl.NumberFormat("es-CO", { style: "currency", currency, maximumFractionDigits: ["COP", "CLP", "PYG"].includes(currency) ? 0 : 2 }).format(Number(value || 0));
}
export function assetUrl(value) {
  if (!value) return "";
  const raw = String(value);
  if (/^https?:\/\//i.test(raw)) return raw;
  if (/^(data:|javascript:|vbscript:|\/\/)/i.test(raw)) return "";
  const base = String(process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");
  return `${base}/public/${raw.replace(/^\/?public\//, "").replace(/^\//, "")}`;
}
export const safeExternalUrl = value => /^https?:\/\//i.test(String(value || "")) ? value : null;
export const statusLabel = status => ({ awaiting_payment: "Pendiente de pago", payment_review: "Pago en revisión", fulfilled: "Entregado", manual_activation: "Activación en proceso", paid: "Pago confirmado", cancelled: "Cancelado", active: "Activo", expired: "Vencido", pending: "Pendiente", draft: "En preparación" })[status] || status;
export function requestKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes).map(b => b.toString(16).padStart(2, "0")).join("");
}

/** Group actual plans for presentation; the cart always receives the original product. */
export function groupStoreProducts(products = []) {
  const groups = new Map();
  products.forEach(product => {
    const name = String(product.fulfillmentType === "giftcard" ? `${product.giftCardBrand || product.name} · Gift cards` : product.name || "Producto").trim().replace(/\s+/g, " ");
    const key = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    if (!groups.has(key)) groups.set(key, { name, variants: [] });
    groups.get(key).variants.push(product);
  });
  const priority = [/netflix/i, /disney/i, /prime|amazon/i, /youtube/i, /paramount/i];
  const rank = name => { const index = priority.findIndex(pattern => pattern.test(name)); return index < 0 ? priority.length : index; };
  return Array.from(groups.values()).map(group => {
    const variants = [...group.variants].sort((a, b) => {
      const availableA = a.stock !== 0 && a.accountPricing?.local > 0;
      const availableB = b.stock !== 0 && b.accountPricing?.local > 0;
      return Number(availableB) - Number(availableA) || (Number(a.accountPricing?.local || Infinity) - Number(b.accountPricing?.local || Infinity)) || a.id - b.id;
    });
    const available = variants.filter(product => product.stock !== 0 && product.accountPricing?.local > 0);
    const first = available[0] || variants[0];
    return { ...first, name: group.name, imageUrl: first.imageUrl || variants.find(product => product.imageUrl)?.imageUrl || "", planLabel: `${variants.length} ${first.fulfillmentType === "giftcard" ? "variantes por región y valor" : variants.length === 1 ? "plan disponible" : "planes para elegir"}`, accountPricing: available.length ? { ...first.accountPricing, varies: true } : null, stock: available.some(product => product.stock == null) ? null : available.reduce((sum, product) => sum + Number(product.stock || 0), 0), variants };
  }).sort((a, b) => rank(a.name) - rank(b.name) || a.name.localeCompare(b.name));
}

export function currencyName(code) {
  try { return `${new Intl.DisplayNames(["es"], { type: "currency" }).of(code)} (${code})`; }
  catch { return code; }
}
export function giftCardRegion(product) {
  const code = product.originCountry;
  if (code === "GLOBAL") return "Global";
  if (code === "LATAM") return "Latinoamérica";
  if (code === "EU") return "Europa";
  try { return new Intl.DisplayNames(["es"], { type: "region" }).of(code) || code; } catch { return code || "Región por confirmar"; }
}
export function variantLabel(product) {
  if (product.fulfillmentType === "giftcard") return `${product.giftCardValue} ${product.giftCardCurrency} · ${giftCardRegion(product)} · Código de un solo uso`;
  const kind = product.sellFullAccount && product.sellByProfile ? "Cuenta completa / perfil"
    : product.sellFullAccount ? "Cuenta completa" : product.sellByProfile ? "Por perfil"
    : product.slotKind === "none" ? "Cuenta completa / servicio" : "Acceso individual";
  return [kind, product.planLabel, product.durationDays > 0 ? `${product.durationDays} días` : ""].filter(Boolean).join(" · ");
}
export function productPrice(product, store, mode = "local") {
  const local = Number(product.accountPricing?.local || 0);
  const fx = Number(product.accountPricing?.fx || 0);
  const rate = Number(store.exchangeRate);
  return mode === "fx" ? { amount: fx > 0 ? fx : rate > 0 ? Math.round(local / rate * 100) / 100 : null, currency: store.currencyFx }
    : { amount: local, currency: store.currency };
}
